import { render, staticRenderFns } from "./HisInfo.vue?vue&type=template&id=d03fed50&scoped=true"
import script from "./HisInfo.vue?vue&type=script&lang=ts"
export * from "./HisInfo.vue?vue&type=script&lang=ts"
import style0 from "./HisInfo.vue?vue&type=style&index=0&id=d03fed50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03fed50",
  null
  
)

export default component.exports